import * as React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
import { Props } from './type'
export const UVFilterIcon = (props: Props) => (
  <Svg viewBox='0 0 60 61' fill='none' {...props}>
    <G clipPath='url(#clip0_5207_7289)'>
      <Path
        d='M25.3125 52.6309H19.0625C18.234 52.6297 17.4398 52.3001 16.854 51.7143C16.2682 51.1285 15.9386 50.3343 15.9375 49.5059V37.0059H19.0625V49.5059H25.3125V37.0059H28.4375V49.5059C28.4364 50.3343 28.1068 51.1285 27.521 51.7143C26.9352 52.3001 26.141 52.6297 25.3125 52.6309Z'
        fill='#859CAD'
      />
      <Path
        d='M44.0625 37.0059H41.3281L37.8125 51.1168L34.3625 37.0059H31.5625L35.4688 52.6309H40.1562L44.0625 37.0059Z'
        fill='#859CAD'
      />
      <Path d='M31.5625 8.88086H28.4375V16.6934H31.5625V8.88086Z' fill='#859CAD' />
      <Path
        d='M44.3631 14.1833L38.8853 19.6611L41.0947 21.8706L46.5726 16.3928L44.3631 14.1833Z'
        fill='#859CAD'
      />
      <Path d='M51.875 29.1934H44.0625V32.3184H51.875V29.1934Z' fill='#859CAD' />
      <Path d='M15.9375 29.1934H8.125V32.3184H15.9375V29.1934Z' fill='#859CAD' />
      <Path
        d='M15.6369 14.1831L13.4274 16.3926L18.9053 21.8704L21.1148 19.661L15.6369 14.1831Z'
        fill='#859CAD'
      />
      <Path
        d='M39.375 32.3184H36.25V30.7559C36.25 29.0983 35.5915 27.5085 34.4194 26.3364C33.2473 25.1643 31.6576 24.5059 30 24.5059C28.3424 24.5059 26.7527 25.1643 25.5806 26.3364C24.4085 27.5085 23.75 29.0983 23.75 30.7559V32.3184H20.625V30.7559C20.625 28.2695 21.6127 25.8849 23.3709 24.1267C25.129 22.3686 27.5136 21.3809 30 21.3809C32.4864 21.3809 34.871 22.3686 36.6291 24.1267C38.3873 25.8849 39.375 28.2695 39.375 30.7559V32.3184Z'
        fill='#859CAD'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_5207_7289'>
        <Rect width={50} height={50} fill='white' transform='translate(5 5.75586)' />
      </ClipPath>
    </Defs>
  </Svg>
)
